/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import '../../../../../Assets/EnsembleStyles/Administration/buildinginstallation.css';
import { GetBuildingsDiscovery,GetBuildingsDiscovered,DeleteFailedInstallations } from '../../../../../action/Administration/administrationAction';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import DeleteConfirmation from '../../../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import { createFilter } from 'react-search-input';
const KEYS_TO_FILTERS = ['siteName', 'requestStatus'];



class InstalledBuildings extends Component {

    async componentDidMount() {
        this.props.GetBuildingsDiscovery();
        try {
            var timer = setInterval(async () => {
                if (this.state.buildings_discovering_list_state !== null && this.state.buildings_discovering_list_state !== undefined) {
                    var results = this.state.buildings_discovering_list_state.map(function (cell, i) {
                        if (cell.requestStatus === 1 && cell.requestStatusText === "Uploading") {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                    var newres = results.includes(true);

                    if (newres === true) {
                        this.props.GetBuildingsDiscovery();
                    }
                    else {
                        this.props.GetBuildingsDiscovered();
                        clearInterval(timer)
                    };
                }
            }, 3000);
        } catch (e) {
            console.log(e);
        }
    }



    componentWillReceiveProps(nextProps) {

        if (this.props != nextProps) {
            this.setState({ buildings_discovering_list_state: nextProps.buildings_discovering_list_response })
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error_msg: false,
            Deletemodal: false,
            searchTermVal: '',
            buildings_discovering_list_state: null,
            aync_function: false,
            sort: {
                column: null,
                direction: 'asc',
            },
        }
        this.searchUpdated = this.searchUpdated.bind(this);
        this.testdun = this.testdun.bind(this);
        this.delete_Failed_Installations = this.delete_Failed_Installations.bind(this);
    }

    /* Filter System */
    testdun() {
        this.props.GetBuildingsDiscovery();
    }

    searchUpdated(term) {
        this.setState({ searchTermVal: term })
    }



  /* Delete Confirmation*/



  Deletetoggle() {
    this.setState({
        Deletemodal: !this.state.Deletemodal
    });
  }


  delete_Failed_Installations() {
    this.setState({ error_msg: false });
    var IsAnyChecked = false;
    var checkboxes = document.getElementsByClassName('Failed_buildings_checkboxes');
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked === true) {
            IsAnyChecked = true;
        }
    }
    if (IsAnyChecked) this.Deletetoggle();
    else this.setState({ error_msg: true });
}


  Delete = (someArg) => {
    if (someArg == "yes") {
        var Data = [];
        var checkboxes = document.getElementsByClassName('Failed_buildings_checkboxes');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var discovery_id_to_be_deleted = {
                    "discoveryRequestId": checkboxes[i].id
                }
                Data.push(discovery_id_to_be_deleted);
            }

        }
        if (Data.length > 0) {
            this.setState({ error_msg: false });
            this.props.DeleteFailedInstallations(Data);
            this.Deletetoggle();
        }
        else {
            this.setState({ error_msg: true });
            this.Deletetoggle();
        }

    }
    else {
        this.Deletetoggle();
    }
}

/* Sorting  System */

onSort = (column) => (e) => {
    const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    var data_from_state = this.state.Discovered_buildings_list_state;
    if(data_from_state != null){
    const sortedData = this.state.Discovered_buildings_list_state.sort((a, b) => {
        if (typeof  a[column] === 'string' && typeof  b[column] === 'string'){
            const nameA = a[column].toLowerCase();
            const nameB = b[column].toLowerCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
         return 0;
        }
        else{   //Checking for integers / numbers
            
            const nameA = a[column];
            const nameB = b[column];

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
         return 0;
        }

           
    });


    if(this.state.sort.direction =='desc'){
          sortedData.reverse();
       
     }
   
    this.setState({
        Discovered_buildings_list_state: sortedData,
        sort: {
            column,
            direction,
        }
    });
}
};



setArrow = (column) => {
    let className = 'sort-direction';
    if (this.state.sort.column === column) {
        className += this.state.sort.direction === 'asc' ? ' asc' : ' desc';
    }
    return className;
};



    render() {

        let data, filteredData, BuildingsList,CountList,Error_Message = null;

        if(this.state.aync_function === true){
            this.props.GetBuildingsDiscovery();
        }

        data = this.state.buildings_discovering_list_state;
        if (data != undefined && data.length > 0 && data != null) {
            filteredData = data.filter(createFilter(this.state.searchTermVal, KEYS_TO_FILTERS));
            if (filteredData.length != 0) {
                BuildingsList = filteredData.map(el => (
                    <tr key={el.discoveryRequestId}>
                        <td  ><input type="checkbox" id={el.discoveryRequestId} className="Failed_buildings_checkboxes" value={el.discoveryRequestId} /></td>
                        <td><label style={{ color: '#6890C6' }}  className="link_cursor">{el.siteName}</label></td>
                        <td>{el.requestStatusText} </td>
                        <td>{el.numberOfPanelsLoaded}{" of "}{el.numberOfPanelsDiscovered}{" Devices Loaded"} </td>
                    </tr>
                ));

                CountList = <p className="count">Items 1 to {filteredData.length} of {filteredData.length}   </p>
            }
            else {
                BuildingsList = <tr><td  colSpan="6">{"No Records Found."}</td></tr>
            }
        }
        else {
            BuildingsList = <tr><td  colSpan="6">{"No Records Found."}</td></tr>
        }

         // Error Message
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error}</p> : Error_Message = " ";
        


        //Rendering
        return (

            <div className="discovery_content2">

                 <div className="tableandbtns">
                <div className="table_div">
            {Error_Message}
                    <div className="table_container">
                        <Table striped responsive className="Custom_table">
                            <tbody>
                                <tr>
                                 <td ><input type="checkbox" className="heading_Check_box"   onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Failed_buildings_checkboxes", "heading_Check_box"); }} /></td>
                                <th onClick={this.onSort('siteName')}  className="link_cursor">Building Name<span className={this.setArrow('siteName')}></span> </th>
                                <th>Status</th>
                                <th onClick={this.onSort('numberOfPanelsLoaded')}  className="link_cursor">Devices Loaded <span className={this.setArrow('numberOfPanelsLoaded')}></span> </th>
                                </tr>
                                {BuildingsList}
                            </tbody> 
                        </Table>
                        {CountList}
                    </div>
                </div>
                <div className="btns_div">
                     <p className="bold_sub_text">Selected&nbsp;Installations</p>
                     {/* <Button className="btn-black btn-md bldng_intllns_btns"   onClick={() => { this.redirect("back_to_administration") }}  > {"Retry"}</Button>
                     <Button className="btn-black btn-md bldng_intllns_btns"   onClick={() => { this.redirect("back_to_administration") }}  > {"Edit"}</Button> */}
                     <Button className="btn-black btn-md bldng_intllns_btns"    onClick={this.delete_Failed_Installations}  > {"Remove"}</Button>
                    </div>
            </div>

              <Modal isOpen={this.state.Deletemodal} deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Installations", "Are you sure you want to delete Installations"]} Delete={this.Delete} />
            </Modal>
            </div>
        );
    }
}




const mapStateToProps = state => {
    return {
     buildings_discovering_list_response: state.InstallationsRootReducer.Installations,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetBuildingsDiscovery: () => dispatch(GetBuildingsDiscovery()),
        GetBuildingsDiscovered: () => dispatch(GetBuildingsDiscovered()),
        DeleteFailedInstallations: (data) => dispatch(DeleteFailedInstallations(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstalledBuildings);
